import { order, orderItem, orderAttachment } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getOrderOptions(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${order.options}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(order.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadOrderSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(order.saleOrderDownload, {
          params: params,
          responseType: "blob",
          headers: {
            Accept: "application/xlsx",
          },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadOrderItemsSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(order.saleOrderItemDownload, {
          params: params,
          headers: {
            Accept: "application/xlsx",
          },
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadAdhocOrderSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(order.adhocOrderDownload, {
          params: params,
          responseType: "blob",
          headers: {
            Accept: "application/xlsx",
          },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadAdhocOrderItemsSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(order.adhocOrderItemDownload, {
          params: params,
          headers: {
            Accept: "application/xlsx",
          },
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  uploadOrderAttachment(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${orderAttachment.base}`, params)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getUploadOrderAttachment(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(orderAttachment.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteOrderDocument(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${orderAttachment.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderItemList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderItem.base}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
